module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-400.woff2?ae3bdea1a1337e878e00c40d5be1e8a4";